var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BFormInput,{staticClass:"directory-form-input",attrs:{"placeholder":_setup.placeholder},on:{"click":_setup.selectFile},model:{value:(_setup.currentValue),callback:function ($$v) {_setup.currentValue=$$v},expression:"currentValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }